<div class="w-100 d-flex justify-content-center mb-2">
    <mat-slide-toggle [(ngModel)]="state" (change)="onStateChanged()" color="primary">
        {{ state ? 'aktiv' : 'inaktiv' }}
    </mat-slide-toggle>
</div>

<!-- {{selectedDoChannel | json}} -->
<div class="w-100 d-flex justify-content-center mb-2">
    <button [disabled]="selectedDoChannel === undefined" class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="createDoControl()"> Manuelle
        Steuerung erstellen</button>
    <button [disabled]="selectedDoChannel === undefined" class="btn btn-outline-danger rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="turnDoControlOff()"> Manuelle
        Steuerung entfernen</button>

</div>